import { Box, Typography } from "@mui/material";
import React from "react";
import COLORS from "../../../constants/Colors";

function TabHeading({
  heading = "Heading",
  hasAction = false,
  actionLabel = "ACTION",
  actionFunc = () => {},
  actionIcon = <></>,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography
          fontSize={"1rem"}
          fontWeight={600}
          sx={{
            letterSpacing: "2px",
            color: COLORS.PRIMARY,
          }}
        >
          {heading.toUpperCase()}
        </Typography>
        <Box
          sx={{
            height: "2px",
            display: "flex",
            flexGrow: 1,
            background: "grey",
            opacity: "0.1",
            marginLeft: "10px",
          }}
        />
        {hasAction && (
          <Typography
            fontSize={"0.8rem"}
            fontWeight={600}
            onClick={actionFunc}
            sx={{
              letterSpacing: "2px",
              color: COLORS.PRIMARY,
              ml: "10px",
              cursor: "pointer",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
            }}
          >
            {React.cloneElement(actionIcon, {
              sx: { fontSize: "1rem", mr: "5px" },
            })}
            {actionLabel}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default TabHeading;
